import { changeRangeValueAction } from './changeRangeValueAction';

export const changeTotalAreaMinAction = (value: number): ReturnType<typeof changeRangeValueAction> =>
  changeRangeValueAction({ fieldName: 'totalArea', rangeValueKey: 'min', value });
